// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.panel-field-option-select[data-v-ed9cd6d6] {\n  margin-top: 20px;\n}\n.panel-field-option-select label[data-v-ed9cd6d6] {\n      display: block;\n      margin-bottom: 5px;\n}\n.panel-field-option-select .panel-field-btn-group[data-v-ed9cd6d6] {\n      display: flex;\n      justify-content: space-between;\n      margin-top: 5px;\n      margin-bottom: 5px;\n}\n", ""]);
// Exports
module.exports = exports;
